import usePermittedQuery from '_api/queries/usePermittedQuery';
import { GoalNote } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_GOAL_NOTES = 'get-goal-notes';

export const useGetGoalNotes = (goalId: number) => {
  return usePermittedQuery<GoalNote[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/goal/all-goal-notes/${goalId}`,
    {},
    [GET_GOAL_NOTES],
    {
      enabled: typeof goalId === 'number' && goalId >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
